import Vue from 'vue';
import Router from 'vue-router';
import store from './store';

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer');

// 404
const Page404 = () => import('@/views/pages/Page404');

// Announcements
const Announcements = () => import('@/views/announcements/Index');
const Announcement = () => import('@/views/announcements/Show');
const AnnouncementCreate = () => import('@/views/announcements/Create');

// Holidays
const Holidays = () => import('@/views/holidays/Index');
const Holiday = () => import('@/views/holidays/Show');
const HolidayCreate = () => import('@/views/holidays/Create');

// Companies
const Companies = () => import('@/views/companies/Index');
const Company = () => import('@/views/companies/Show');
const CompanyCreate = () => import('@/views/companies/Create');

// Companies
const Orders = () => import('@/views/orders/Index');
const OrdersImport = () => import('@/views/orders/Import');
const Order = () => import('@/views/orders/Show');

// Locations
const Locations = () => import('@/views/locations/Index');
const Location = () => import('@/views/locations/Show');
const LocationCreate = () => import('@/views/locations/Create');

// Locations
const Users = () => import('@/views/users/Index');
const User = () => import('@/views/users/Show');
const UserCreate = () => import('@/views/users/Create');

// Profile
const Profile = () => import('@/views/profile/Show');

// Login
const Login = () => import('@/views/login/Login');
const PasswordForgot = () => import('@/views/login/PasswordForgot');
const PasswordReset = () => import('@/views/login/PasswordReset');
const ActivateAccount = () => import('@/views/login/ActivateAccount');

const Dashboard = () => import('@/views/pages/Dashboard');

Vue.use(Router);

const router = new Router({
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/admin',
      name: 'admin',
      redirect: 'admin/dashboard',
      component: DefaultContainer,
      children: [
        {
          path: 'dashboard',
          name: 'dashboard',
          component: Dashboard,
        },
        {
          path: 'profile',
          name: 'profile',
          component: Profile,
        },
        {
          path: 'announcements',
          name: 'announcements',
          component: Announcements,
        },
        {
          path: 'announcements/toevoegen',
          name: 'announcements.create',
          component: AnnouncementCreate,
        },
        {
          path: 'announcements/:id',
          name: 'announcements.view',
          component: Announcement,
        },
        {
          path: 'holidays',
          name: 'holidays',
          component: Holidays,
        },
        {
          path: 'holidays/toevoegen',
          name: 'holidays.create',
          component: HolidayCreate,
        },
        {
          path: 'holidays/:id',
          name: 'holidays.view',
          component: Holiday,
        },
        {
          path: 'companies',
          name: 'companies',
          component: Companies,
        },
        {
          path: 'companies/toevoegen',
          name: 'companies.create',
          component: CompanyCreate,
        },
        {
          path: 'companies/:id',
          name: 'companies.view',
          component: Company,
        },
        {
          path: 'locations',
          name: 'locations',
          component: Locations,
        },
        {
          path: 'locations/toevoegen',
          name: 'locations.create',
          component: LocationCreate,
        },
        {
          path: 'locations/:id',
          name: 'locations.view',
          component: Location,
        },
        {
          path: 'users',
          name: 'users',
          component: Users,
        },
        {
          path: 'users/toevoegen',
          name: 'users.create',
          component: UserCreate,
        },
        {
          path: 'users/:id',
          name: 'users.view',
          component: User,
        },
        {
          path: 'orders',
          name: 'orders',
          component: Orders,
        },
        {
          path: 'orders/importeren',
          name: 'orders.import',
          component: OrdersImport,
        },
        {
          path: 'orders/:id',
          name: 'orders.view',
          component: Order,
        },
      ],
    },
    {
      path: '/',
      name: 'login-main',
      redirect: '/login',
      component: {
        render(c) {
          return c('router-view');
        },
      },
      children: [
        {
          path: 'login',
          name: 'login',
          component: Login,
        },
        {
          path: 'forgot-password',
          name: 'forgot-password',
          component: PasswordForgot,
        },
        {
          path: 'reset-password',
          name: 'reset-password',
          component: PasswordReset,
        },
        {
          path: 'activate-account',
          name: 'activate-account',
          component: ActivateAccount,
        },
      ],
    },
    {
      path: '*',
      component: Page404,
    },
  ],
});

router.beforeEach((to, from, next) => {
  store.dispatch('fetchAccessToken');
  if (to.fullPath.includes('admin')) {
    if (!store.state.accessToken) {
      next('/login');
    }
  }
  if (to.fullPath === '/login') {
    if (store.state.accessToken) {
      next('/admin');
    }
  }
  next();
});

export default router;
